import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as en } from "@/common/config/i18n/en";
import { locale as id } from "@/common/config/i18n/id";
import { locale as ptbr } from "@/common/config/i18n/pt-br";
import { locale as ptpt } from "@/common/config/i18n/pt-pt";
import { locale as es } from "@/common/config/i18n/es";
import { locale as de } from "@/common/config/i18n/de";
import { locale as fr } from "@/common/config/i18n/fr";
import i18nService from "@/common/i18n.service.js";

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, en, id, ptbr, "pt-pt": ptpt, es, de, fr };

// get current selected language
const lang = i18nService.getActiveLanguage();

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: "en",
  messages, // set locale messages
});

i18nService.onLanguageChanged((language) => {
  i18n.locale = language;
});

export default i18n;
